import { Component, OnInit } from '@angular/core';
import { ReadingService } from 'src/app/services/text/reading.service';
import { ReadingActions } from 'src/app/core/enums';
import { ReaderStatus, SpeakingJobType } from 'src/app/core/reading-utils/enums';
import { CurrentUiStoreService } from 'src/app/services/ui/current-ui-store.service';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { NgClass } from '@angular/common';
import { MainClickDirectiveDirective } from '../../utils/directives/main-click-directive.directive';
import { TooltipDirective } from '../../utils/directives/tooltip.directive';

@Component({
    selector: 'asg-reading-toolbar',
    templateUrl: './reading-toolbar.component.html',
    styleUrls: ['./reading-toolbar.component.scss'],
    standalone: true,
    imports: [TooltipDirective, MainClickDirectiveDirective, NgClass]
})
export class ReadingToolbarComponent implements OnInit {
  private _isPlaying: boolean = false;

  constructor(
    private readingService: ReadingService,
    private uiStoreService: CurrentUiStoreService
    ) { }

  get isPlaying(): boolean { return this._isPlaying }

  get readingIsLocked(): boolean {
    return this.uiStoreService.uiState.value[AsgardFeatureNames.SPEECH].locked;
  }

  ngOnInit(): void {
    this.readingService.readingStatusObservable.subscribe(status => {
      const activeJob = this.readingService.activeSpeakingJob;
      this._isPlaying = status === ReaderStatus.Speaking && activeJob !== SpeakingJobType.Tooltip;
    })
  }

  onPlayOrPause = () => {
    this.readingService.runAction(ReadingActions.PlayPause);
  }

  moveForward = () => {
    this.readingService.runAction(ReadingActions.MoveForward);
  }

  moveBackward = () =>  {
    this.readingService.runAction(ReadingActions.MoveBackward);
  }
}
